var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { useState } from "react";
import { v4 as uuid } from "uuid";
import { useTheme } from "styled-components";
import { TNotificationType } from "./NotificationTypes";
export var useNotificationsCtxProvider = function () {
    var _a = useState([]), notifications = _a[0], setNotifications = _a[1];
    var transitions = useTheme().transitions;
    var addNotification = function (message, type) {
        if (type === void 0) { type = TNotificationType.success; }
        var id = uuid();
        setNotifications(__spreadArray([
            { id: id, message: message, type: type, dateAdded: new Date() }
        ], notifications));
        setTimeout(function () {
            var index = -1;
            notifications.forEach(function (n, i) {
                if (n.id === id) {
                    index = i;
                }
            });
            var newNotifications = __spreadArray([], notifications);
            newNotifications.splice(index, 1);
            setNotifications(newNotifications);
        }, parseInt(transitions.notification.replace("ms", "")));
    };
    return {
        notifications: notifications,
        addNotification: addNotification,
    };
};
//# sourceMappingURL=useNotificationsCtxProvider.js.map